import { loaders } from 'entities';

import { Logs } from 'components/Logs';

import { usePackage } from './context';

export function PackageEvents(): JSX.Element {
  const { data } = usePackage();

  const { data: events, errorOrLoading } = loaders.invoice.packageEvents.use({
    defaultValue: [],

    params: {
      packageId: data.id,
    },

    reloadOnChangeRef: data.id,
  });

  return <Logs loading={errorOrLoading} logs={events} />;
}
